/**
 * Оба списка фильтров — сотрудники и проекты — делятся по одному правилу:
 * надёжная часть сразу, сомнительная под раскрывашкой. Ничего не выбрасывается,
 * поэтому правило живёт здесь, а не в двух копиях.
 */

export interface Partition<T> {
  active: T[];
  inactive: T[];
  /** Выбранные неактивные: они не должны прятаться в свёрнутом блоке. */
  selectedInactive: number;
}

interface Options<T> {
  search: string;
  selected: string[];
  isActive: (item: T) => boolean;
  id: (item: T) => string;
  /** Всё, по чему ищем: имя человека либо код и название проекта. */
  text: (item: T) => string[];
}

export function partition<T>(items: T[], options: Options<T>): Partition<T> {
  const needle = options.search.trim().toLowerCase();
  const matches = (item: T) =>
    needle === '' || options.text(item).some((value) => value.toLowerCase().includes(needle));

  const selected = new Set(options.selected);
  const visible = items.filter(matches);

  return {
    active: visible.filter(options.isActive),
    inactive: visible.filter((item) => !options.isActive(item)),
    selectedInactive: items.filter(
      (item) => !options.isActive(item) && selected.has(options.id(item)),
    ).length,
  };
}

/**
 * Нужно ли раскрыть неактивных без просьбы пользователя: он ищет (а совпадения
 * лежат внутри) или что-то из неактивных уже выбрано.
 */
export function shouldRevealInactive<T>(part: Partition<T>, search: string): boolean {
  if (part.selectedInactive > 0) return true;
  return search.trim() !== '' && part.inactive.length > 0;
}
